import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, Output } from '@angular/core';
import { AppConstants } from '../../app.constants';
import { ToolbarService } from './toolbar.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: false
})
export class ToolbarComponent {

  @Output() toggleSidenav = new EventEmitter<void>();
  isHandset = false;
  showUserInfo: boolean = false;
  showExtraPageMenu: boolean = false;
  user: any;
  shopName: String;

  constructor(private breakpointObserver: BreakpointObserver, private toolbarService: ToolbarService) {
    this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((state: BreakpointState) => {
      this.isHandset = state.matches;
      if (this.isHandset) {
        this.toolbarService.isVisible = false;
      }
    });
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = (sesUser !== null) ? JSON.parse(sesUser) : undefined;
    this.shopName = "";
    if (this.user.user_type == "SHOP") {
      this.shopName = "[ " + this.user.shop_info.name + " ]";
    } else if (this.user.user_type == "HQ") {
      this.shopName = "[ HQ ]";
    } else if (this.user.user_type == "AREA_MANAGER") {
      this.shopName = "[ AREA MANAGER ]";
    }
  }

  toggle(): void {

    if (this.isHandset) {
      this.toggleSidenav.emit();
    } else {
      this.toolbarService.onToggleOptionBar();
    }
  }

}

